import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Tooltip,
	Typography
} from "@mui/material";
import Button from "@mui/material/Button";
import {TicketContext} from "../../../../App";
import {useHistory} from "react-router-dom";
import SollecitaTicket from "../../ticket/storico/SollecitaTicket";
import {getTicketHistory} from "../../../../services/TicketServices";
import clsx from "clsx";
import useTicketSearch from "../../ticket/utils/useTicketSearch";
import useGetAllTicket from "../../ticket/utils/useGetAllTicket";
import TicketCard from "../../ticket/details/TicketCard";
import { Alert, AlertTitle, Skeleton } from '@mui/material';

const StoricoCard = ({
	                     showButton, isCcm = false, style,
	                     subheader = "Qui trovi tutti i ticket da te registrati nelle ultime 72h",
	                     value = "", useSearch = false, firstLevel = true
                     }) => {
	const classes = BaseStyle();
	const history = useHistory();
	const ticketContext = useContext(TicketContext);
	const [ticketSelected, setTicketSelected] = useState();
	const [openDialog, setOpenDialog] = useState(false);
	const [pageNumber, setPageNumber] = useState(0);
	const observer = useRef();

	/**
	 * Cerca in modo figo un ticket in base al value passatogli
	 */
	const {loadingSearch, errorSearch, ticketSearch, hasMoreSearch} = useTicketSearch(value, pageNumber, false);
	/**
	 * Get di tutti i ticket in cui io operatore ho messo mano (anche solo uno storico)
	 */
	const {
		loading,
		error,
		tickets,
		hasMore
	} = useGetAllTicket("Le mie richieste", "CCM", pageNumber, null, null, "dataUltimaModifica", "ASC", null, null, null, null)

	const lastTicketElementRef = useCallback(node => {
		if (loading) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMore) {
				setPageNumber(prevState => prevState + 1);
				//getAllInfo(ticketContext.dispatch);
			}
			if (entries[0].isIntersecting && hasMoreSearch) {
				setPageNumber(prevState => prevState + 1);
				//getAllInfo(ticketContext.dispatch);
			}
		})
		if (node) observer.current.observe(node)
	}, [loading, hasMore, hasMoreSearch])

	const seeAll = useCallback(() => {
		history.push("/gestione/callcenter/search");
	}, [history])

	const seeMyTicket = useCallback(() => {
		history.push("/gestione/callcenter/mytickets");
	}, [history])

	const onClickDetails = useCallback((ticket) => {
		setTicketSelected(ticket);
		getTicketHistory(ticket, ticketContext.dispatch);
		setOpenDialog(true);
	}, [ticketContext.dispatch]);

	useEffect(() => {
		setPageNumber(0);
	}, [value])

	return (
        <React.Fragment>
            <Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Storico ticket</b></Typography>}
					subheader={showButton ? (tickets.length > 0 ? "I ticket da te registrati nelle ultime 72h" : "Ticket del paziente che cerchi") : subheader}
				/>
				<CardContent style={style ? style : {flexGrow: 1}}>

					{
						(useSearch ? ticketSearch : firstLevel ? ticketContext.state.searchedTickets : tickets).map((ticket, index) => {
							if (tickets.length === index + 1) {
								return (
									<Card ref={lastTicketElementRef} key={ticket.id}
									      className={clsx(classes.roundBorder, classes.mailCard)}>
										<TicketCard ticket={ticket} setValue={() => {
										}} handleTicketSelect={onClickDetails}/>
									</Card>
								)
							} else {
								return (
									<Card key={ticket.id} className={clsx(classes.roundBorder, classes.mailCard)}>
										<TicketCard ticket={ticket} setValue={() => {
										}} handleTicketSelect={onClickDetails}/>
									</Card>
								)
							}
						})
					}
					{
						!useSearch && firstLevel && !ticketContext.state.loadingSearchTicket && ticketContext.state.errorSearchTicket === "" && ticketContext.state.searchedTickets.length === 0 &&
						<Alert severity="info" style={{borderRadius: 24}}>
							<AlertTitle>Nessun risultato 😕</AlertTitle>
							Nessun ticket rispecchia le specifiche richieste o non hai ancora cercato
						</Alert>
					}
					{
						!useSearch && firstLevel && ticketContext.state.loadingSearchTicket && ticketContext.state.errorSearchTicket === "" &&
						<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
							<CardHeader
								avatar={<Skeleton variant="circular" height={40} width={40}/>}
								title={<Skeleton width={180}/>}
								subheader={<Skeleton width={260}/>}
								action={<Skeleton variant="circular" height={20} width={20}/>}
								style={{paddingBottom: 2}}
							/>
							<CardContent style={{paddingTop: 0, marginTop: -35}}>
								<Skeleton height={200}/>
							</CardContent>
						</Card>
					}
					{
						!useSearch && firstLevel && !ticketContext.state.loadingSearchTicket && ticketContext.state.errorSearchTicket !== "" &&
						<Alert severity="error" style={{borderRadius: 24}}>
							<AlertTitle>Errore</AlertTitle>
							Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
							sviluppatori.
						</Alert>
					}

					{
						!firstLevel && !loading && !error && tickets.length === 0 &&
						<Alert severity="info" style={{borderRadius: 24}}>
							<AlertTitle>Nessun risultato 😕</AlertTitle>
							Non hai ancora registrato ticket a nome tuo
						</Alert>
					}
					{
						!firstLevel && loading && !error &&
						<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
							<CardHeader
								avatar={<Skeleton variant="circular" height={40} width={40}/>}
								title={<Skeleton width={180}/>}
								subheader={<Skeleton width={260}/>}
								action={<Skeleton variant="circular" height={20} width={20}/>}
								style={{paddingBottom: 2}}
							/>
							<CardContent style={{paddingTop: 0, marginTop: -35}}>
								<Skeleton height={200}/>
							</CardContent>
						</Card>
					}
					{
						!firstLevel && !loading && error &&
						<Alert severity="error" style={{borderRadius: 24}}>
							<AlertTitle>Errore</AlertTitle>
							Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
							sviluppatori.
						</Alert>
					}

					{
						value !== "" && !loadingSearch && !errorSearch && ticketSearch.length === 0 &&
						<Alert severity="info" style={{borderRadius: 24}}>
							<AlertTitle>Nessun risultato 😕</AlertTitle>
							Nessun ticket rispecchia le specifiche richieste o non hai ancora cercato
						</Alert>
					}
					{
						value !== "" && loadingSearch && !errorSearch &&
						<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
							<CardHeader
								avatar={<Skeleton variant="circular" height={40} width={40}/>}
								title={<Skeleton width={180}/>}
								subheader={<Skeleton width={260}/>}
								action={<Skeleton variant="circular" height={20} width={20}/>}
								style={{paddingBottom: 2}}
							/>
							<CardContent style={{paddingTop: 0, marginTop: -35}}>
								<Skeleton height={200}/>
							</CardContent>
						</Card>
					}
					{
						value !== "" && !loadingSearch && errorSearch &&
						<Alert severity="error" style={{borderRadius: 24}}>
							<AlertTitle>Errore</AlertTitle>
							Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
							sviluppatori.
						</Alert>
					}

				</CardContent>
				{showButton && <CardActions className={classes.flexRight}>
					<Tooltip
						title={"Visualizza tutti i ticket da te inviati per visualizzare il loro stato"}>
						<Button variant={"text"} size={"small"} disableElevation color="inherit"
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={seeMyTicket}>
							<b>Le mie richieste</b>
						</Button>
					</Tooltip>
					<Tooltip
						title={"Cerca nuovi ticket o visualizza tutti i ticket (in grande) del paziente in questione"}>
						<Button variant={"contained"} size={"small"} disableElevation color="primary"
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={seeAll}>
							<b>Cerca</b>
						</Button>
					</Tooltip>
				</CardActions>}
			</Card>
            {openDialog && <SollecitaTicket open={openDialog} onClose={setOpenDialog} ticket={ticketSelected}/>}
        </React.Fragment>
    );
};

export default React.memo(StoricoCard);
